import type { ReactNode } from 'react'
import { MainLayout } from '@/shared/components/Layout'

interface MainLayoutRouteProps {
  children: ReactNode
}

export const MainLayoutRoute = ({ children }: MainLayoutRouteProps) => {
  return <MainLayout>{children}</MainLayout>
}
